import React from "react";

import Picture from "../assets/pic-1-4.png";

const About = () => {
  return (
    <div
      name="about"
      className="w-full sm:h-[90vh] h-[125vh] bg-[#0a192f] text-gray-300"
    >
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="min-w-[195px] sm:text-left pb-8 pl-4">
            <p
              id="about"
              className="text-4xl font-bold inline-block border-b-4 border-cyan-600"
            >
              About me
            </p>
          </div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-justify text-base text-[#8892b0]">
            <p>
              I am dedicated to creating quality code and exceptional user
              experiences.
            </p>
            <div className="py-4">
              <p>
                As a top graduate in Computer Engineering, I bring a strong{" "}
                <strong>focus</strong> and <strong>machine-like</strong> work
                ethic to every project. My diverse expertise in electronics and
                software, particularly as a JavaScript-based developer
                proficient in backend development, C, Python, and other
                languages, allows me to tackle a wide range of challenges.
              </p>
            </div>
            <div>
              If you have an idea you'd like to discuss, feel free to reach out!
            </div>
          </div>
          <div className="group relative max-w-[25rem] mx-auto">
            <img
              className="transition duration-500 filter brightness-[.85] group-hover:brightness-125"
              src={Picture}
              alt="Beki's trophy pic"
            />
            <div className="absolute opacity-30 w-1/2 top-[53%] group-hover:opacity-100 bg-[#0a192f6f] text-white text-sm font-semibold px-3 py-1 border-2 border-[#545e6c5b] rounded-lg group-hover:animate-none animate-pulse">
              1<sup>st</sup> Place in Computer Engineering Department
            </div>
            <div className="absolute opacity-30 left-[60%] top-[73%] group-hover:opacity-100 bg-[#0a192f6f] text-white text-sm font-semibold px-3 py-1 border-2 border-[#545e6c5b] rounded-lg group-hover:animate-none animate-pulse">
              Student of the Year 2024
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
